import { render } from "./HeaderCatalog.vue?vue&type=template&id=cd3d5f88&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./HeaderCatalog.vue?vue&type=script&lang=js"
export * from "./HeaderCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__